const ITEMS = [
  "AI Strategy",
  "Intelligent Automation",
  "AI Agents",
  "Business Systems",
  "Workflow Integration",
  "Lead Automation",
  "Customer Support AI",
  "Process Automation",
];

export const Marquee = () => {
  const doubled = [...ITEMS, ...ITEMS];
  return (
    <div className="relative py-12 lg:py-16 border-y border-[#00F2FE]/10 overflow-hidden" data-testid="editorial-marquee">
      <div className="flex w-max animate-marquee-slow items-center">
        {doubled.map((item, i) => (
          <span key={i} className="flex items-center shrink-0">
            <span className="font-['Outfit'] font-light text-4xl lg:text-6xl tracking-tight text-outline px-8 whitespace-nowrap">
              {item}
            </span>
            <span className="w-2.5 h-2.5 rounded-full bg-[#10E59A]/60 shrink-0" />
          </span>
        ))}
      </div>
    </div>
  );
};
